import React, { useState } from "react";
import '../../../styles/document.css';
import FlagXMK from "../../flags/FlagXMK";
import { config } from "../../../config";
import QRCode from "react-qr-code";
import Translator from "../../../services/Translator";

const CARD_W = 360;
const CARD_H = 227;

const sideStyle = (side: 'obverse' | 'reverse'): React.CSSProperties => ({
    position: 'absolute',
    inset: 0,
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden',
    width: CARD_W + 'px',
    height: CARD_H + 'px',
    border: '1px solid #ffff',
    borderRadius: '10px',
    background: `#eee url('${config.api}/public/documents/identity-card/bg/placeholder/${side}?mobile') no-repeat top right`,
    backgroundSize: 'cover',
    margin: '0 auto',
});

export default function SeriesB({ document, token, lang }: any)
{
    const [flipped, setFlipped] = useState(false);
    const series = document.identity_card_number.substring(0, 3);
    const [bgData, setBgData] = useState<Partial<Record<'obverse' | 'reverse', string>>>({});

    const bg = (side: 'obverse' | 'reverse'): React.CSSProperties => {
        if (!bgData[side]) {
            fetch(`${config.api}/documents/identity-card/bg/${series}/${side}?w=${CARD_W}&h=${CARD_H}&mobile`, {
                headers: { Authorization: 'Bearer ' + token },
            })
                .then(res => {
                    // if (!res.ok) throw new Error(res.status);
                    return res.blob();
                })
                .then(
                    blob =>
                        new Promise<string>((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = () => resolve(reader.result as string);
                            reader.onerror = reject;
                            reader.readAsDataURL(blob); // base64 data URL
                        })
                )
                .then(dataUrl => setBgData(prev => ({ ...prev, [side]: dataUrl })))
                .catch(console.error);
        }

        return {
            ...sideStyle(side),
            background: bgData[side]
                ? `#eee url('${bgData[side]}') no-repeat top right`
                : '#eee'
        };
    };

    return (
        <div>
            <div style={{ width: CARD_W + 'px', margin: '0 auto', perspective: '1200px', paddingTop: '10px' }}>
                <div
                    style={{
                        position: 'relative',
                        width: CARD_W + 'px',
                        height: CARD_H + 'px',
                        transformStyle: 'preserve-3d',
                        transition: 'transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1)',
                        transform: flipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                    }}
                >
                    <div style={bg('obverse')}>
                        <div style={{position: 'relative', top: '9px', left: '16px'}}>
                            <FlagXMK />
                        </div>

                        <img src={'data:image/png;base64,' + document.photo}
                             style={{position: 'relative', top: '30px', left: '14px', width: '111px', height: '129px', display: 'block'}}
                             alt={document.given_names + ' ' + document.surname}
                             className="img-fluid"
                        />
                        <span style={{position: 'relative', width: '225px', top: '-89px', left: '134px', display: 'block', fontSize: '0.9rem', color: '#000'}}>{document.given_names}</span>
                        <span style={{position: 'relative', width: '225px', top: '-74px', left: '134px', display: 'block', fontSize: '0.9rem', fontWeight: 700, color: '#000'}}>{document.surname}</span>
                        <span style={{position: 'relative', width: '225px', top: '-58px', left: '134px', display: 'block', fontSize: '0.9rem', color: '#000'}}>{document.date_of_birth}</span>
                        <span style={{position: 'relative', width: '110px', top: '-46px', left: '247px', display: 'block', fontSize: '0.9rem', color: '#000'}}>{document.eseo}</span>
                    </div>

                    <div style={{ ...bg('reverse'), transform: 'rotateY(180deg)' }}>
                        <span style={{position: 'relative', width: '225px', top: '24px', left: '14px', display: 'block', fontSize: '0.9rem', fontWeight: 700, color: '#000'}}>{document.identity_card_number}</span>
                        <span style={{position: 'relative', width: '225px', top: '40px', left: '14px', display: 'block', fontSize: '0.9rem', color: '#000'}}>{document.date_of_issue}</span>
                        <span style={{position: 'relative', width: '225px', top: '56px', left: '14px', display: 'block', fontSize: '0.9rem', color: '#000'}}>{document.expiry_date}</span>
                        <span style={{position: 'relative', width: '225px', top: '36px', left: '180px', display: 'block', fontSize: '0.9rem', fontWeight: 700, color: '#000'}}>{document.sex}</span>

                        <div style={{position: 'relative', width: '107px', height: '107px', top: '-69px', left: '234px', background: 'white', padding: '10px', margin: '0'}}>
                            <QRCode value={document.qr} style={{width: '88px', height: '88px'}} />
                        </div>

                        <div className={'ocr-b'} style={{position: 'relative', width: '365px', height: '50px', top: '-30px', left: '14px', fontSize: '0.65rem', letterSpacing: '2px'}}>
                            {document.mrz}
                        </div>
                    </div>
                </div>

                <button
                    className={'btn btn-primary'}
                    onClick={() => setFlipped(f => !f)}
                    style={{ display: 'block', margin: '12px auto 0' }}
                >
                    {Translator.trans(lang, 'common.rotate')}
                </button>
            </div>

            <div style={{background: '#ffeecc', padding: '30px', marginTop: '20px'}}>
                <div style={{width: '200px', height: '200px', background: 'white', padding: '20px', margin: '20px auto'}}>
                    <QRCode value={document.mrz} style={{width: '160px', height: '160px'}} />
                </div>
            </div>
        </div>
    );
}